import { toastr } from "react-redux-toastr";
import api from "APP_ROOT/api";
import { reservedForRepairInventoryActions } from "MODULES/RepairOrders/actions";
import { refreshCarts } from "MODULES/session/actions";
import { createChannel } from "APP_ROOT/cable";
import * as actionTypes from "./actionTypes";

export function create(id) {
  return dispatch =>
    api.inventories.repairOrdersCart.create(id).then(({ data }) => {
      dispatch(refreshCarts());
      dispatch({ type: actionTypes.ADD, repairOrderCartItems: data });
      toastr.success("Success", "Item successfully added to cart.");
    });
}

export function destroy(inventoryId) {
  return dispatch => {
    dispatch({ type: actionTypes.REMOVE, id: inventoryId });
    return api.inventories.repairOrdersCart.delete(inventoryId).then(() => {
      dispatch(refreshCarts());
      dispatch(reservedForRepairInventoryActions.expire());
    });
  };
}

export function clearCart() {
  return dispatch =>
    api.inventories.repairOrdersCart.clearCart().then(() => {
      dispatch(refreshCarts());
      dispatch(reservedForRepairInventoryActions.expire());
    });
}

export function subscribe() {
  return dispatch =>
    createChannel().listen("RepairCartChannel", {
      onReceive: data => {
        if (data === "UPDATE") {
          dispatch(refreshCarts());
        }
      }
    });
}



// WEBPACK FOOTER //
// ./app/Nav/RepairOrdersCart/actions.js